import { api } from '@shared/config/axiosConfig';
import { mapPaginationResponse } from '@shared/utils/mapPaginationResponse';
import { buildEndpoint } from '@shared/utils/buildEndpoint';
import { departmentFromDto } from '../mappers/departmentsMapper';

const BASE_ENDPOINT = 'location/departments';

const buildServiceEndpoint = ({ id, action } = {}) => {
  return buildEndpoint(BASE_ENDPOINT, { id, action });
};

export const getDepartment = async (id) => {
  const endpoint = buildServiceEndpoint({ id });
  const response = await api.get(endpoint);
  return departmentFromDto(response.data);
};

export const getDepartments = async (data = {}) => {
  const params = {
    search_text: data.searchText,
    ids: data.ids,
    codes: data.codes,
    page: data.page,
    page_size: data.pageSize,
  };

  const endpoint = buildServiceEndpoint();
  const response = await api.get(endpoint, { params });
  return mapPaginationResponse(response, departmentFromDto);
};
